import { Loader2 } from "lucide-react";

export function LoadingOverlay() {
  const themeColor = localStorage.getItem('theme-primary-color') || '#AC9477';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white backdrop-blur-sm">
      <Loader2 className="h-8 w-8 animate-spin" style={{ color: themeColor }} />
    </div>
  );
}
